import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import { data, activePlace, ROUTE, isEditing, onMembers, onGovernors, onKingdoms } from '../../common/community';
import { overview, loadOverview } from '../../common/overview';
import InviteModal from './InviteModal';
import { governorsHero } from '../../common/governorsHero';

/** The tag-style banner for My Community: places as tabs, then quick facts. */
export default class CommunityHero extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    if (data().state === 'ok') loadOverview().then(() => m.redraw()).catch(() => {});
  }
  view() {
    const d = data();
    if (onMembers()) return this.membersHero();
    if (onKingdoms()) {
      return m("header", {
        className: "Hero VouchaCommunityHero VGovHero"
      }, m("div", {
        className: "container"
      }, m("div", {
        className: "containerNarrow"
      }, m("h1", {
        className: "Hero-title"
      }, m("i", {
        className: "fas fa-crown",
        "aria-hidden": "true"
      }), " Nigeria's traditional kingdoms"), m("div", {
        className: "Hero-subtitle"
      }, "Kingdoms and emirates in every state, with their titles, rulers and history."))));
    }
    if (onGovernors()) {
      return m("header", {
        className: "Hero VouchaCommunityHero VGovHero",
        style: governorsHero() ? {
          backgroundImage: 'linear-gradient(rgba(20, 52, 48, 0.86), rgba(20, 52, 48, 0.9)), url("' + governorsHero() + '")'
        } : undefined
      }, m("div", {
        className: "container"
      }, m("div", {
        className: "containerNarrow"
      }, m("h1", {
        className: "Hero-title"
      }, m("i", {
        className: "fas fa-landmark",
        "aria-hidden": "true"
      }), " Nigeria's governors"), m("div", {
        className: "Hero-subtitle"
      }, "Explore performance, compare governance, and learn more about the governors leading Nigeria, based on key figures and data."))));
    }
    const active = activePlace();
    const setup = d.state !== 'ok' || isEditing();
    return m("header", {
      className: "Hero VouchaCommunityHero"
    }, m("div", {
      className: "container"
    }, m("div", {
      className: "containerNarrow"
    }, m("h1", {
      className: "Hero-title"
    }, m("i", {
      className: "fas fa-users",
      "aria-hidden": "true"
    }), " My Community"), setup ? m("div", {
      className: "Hero-subtitle"
    }, d.state === 'guest' ? 'Ask, share and meet people who get it.' : 'Tell us where you live and where you’re from. It takes about 30 seconds.') : [m("nav", {
      className: "VouchaCommunityHero-tabs"
    }, m("a", {
      className: 'VouchaCommunityHero-tab' + (!active ? ' is-active' : ''),
      href: app.route(ROUTE)
    }, "All"), d.places.map(p => m("a", {
      className: 'VouchaCommunityHero-tab' + (active && active.key === p.key ? ' is-active' : ''),
      href: app.route(ROUTE, {
        place: p.key
      }),
      title: p.full
    }, m("i", {
      className: p.icon,
      "aria-hidden": "true"
    }), " ", p.label)), d.places.some(p => p.stateId) ? m("button", {
      className: "VouchaCommunityHero-tab VouchaCommunityHero-invite",
      onclick: () => app.modal.show(InviteModal)
    }, m("i", {
      className: "fas fa-user-plus",
      "aria-hidden": "true"
    }), " Invite") : null), this.facts(d, active)])));
  }
  facts(d, active) {
    const o = overview();
    if (!o || o.state !== 'ok') return null;
    const week = o.activity ? o.activity[active ? active.key : 'all'] : null;
    const ranks = o.rankings || {};
    const items = [];

    // Interim ranking: population, clearly labelled. One chip for the chosen place,
    // or one per Nigerian place on "All" (the same state is only listed once).
    const keys = active ? [active.key] : d.places.map(p => p.key);
    const seen = {};
    keys.forEach(k => {
      const r = ranks[k];
      if (!r || seen[r.state]) return;
      seen[r.state] = true;
      items.push(m("span", {
        className: "VouchaCommunityHero-fact",
        title: 'Ranked by ' + r.measure + ' (' + r.period + ', ' + r.source + '). An interim measure, not a quality score.'
      }, m("i", {
        className: "fas fa-chart-bar",
        "aria-hidden": "true"
      }), " ", r.state, ": ", m("strong", null, "#", r.rank), " of ", r.of, " by ", r.measure, active ? ' · ' + (r.key === 'composite' ? 'score ' + Math.round(r.value) + '/100' : r.key === 'gdp_faac' ? r.value.toFixed(1) + '× GDP per ₦ of FAAC' : (r.value / 1e6).toFixed(1) + 'M people (' + r.period + ')') : ''));
    });
    if (o.abroad && o.money) {
      items.push(m("span", {
        className: "VouchaCommunityHero-fact"
      }, m("i", {
        className: "fas fa-exchange-alt",
        "aria-hidden": "true"
      }), " 1 ", o.money.currency, " = \u20A6", Number(o.money.ngn).toLocaleString('en-US', {
        maximumFractionDigits: 2
      })));
    }
    if (week !== null && week !== undefined) {
      items.push(m("span", {
        className: "VouchaCommunityHero-fact"
      }, m("i", {
        className: "far fa-comments",
        "aria-hidden": "true"
      }), " ", week === 0 ? 'No new discussions this week yet' : week + (week === 1 ? ' new discussion' : ' new discussions') + ' this week'));
    }
    return items.length ? m("div", {
      className: "VouchaCommunityHero-facts"
    }, items) : null;
  }
  simpleHero(icon, title) {
    return m("header", {
      className: "Hero VouchaCommunityHero"
    }, m("div", {
      className: "container"
    }, m("div", {
      className: "containerNarrow"
    }, m("h1", {
      className: "Hero-title"
    }, m("i", {
      className: icon,
      "aria-hidden": "true"
    }), " ", title), m("div", {
      className: "Hero-subtitle"
    }, m("a", {
      className: "VouchaCommunityHero-back",
      href: app.route(ROUTE)
    }, m("i", {
      className: "fas fa-arrow-left",
      "aria-hidden": "true"
    }), " My Community")))));
  }
  membersHero() {
    return m("header", {
      className: "Hero VouchaCommunityHero"
    }, m("div", {
      className: "container"
    }, m("div", {
      className: "containerNarrow"
    }, m("h1", {
      className: "Hero-title"
    }, m("i", {
      className: "fas fa-user-friends",
      "aria-hidden": "true"
    }), " Members near you"), m("div", {
      className: "Hero-subtitle"
    }, m("a", {
      className: "VouchaCommunityHero-back",
      href: app.route(ROUTE)
    }, m("i", {
      className: "fas fa-arrow-left",
      "aria-hidden": "true"
    }), " My Community")))));
  }
}
flarum.reg.add('voucha-community', 'forum/components/CommunityHero', CommunityHero);